import { Link } from '@tanstack/react-router'
import { Card } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { ArrowLeft } from 'lucide-react'
import AuthLayout from '../auth-layout'

export default function TermsOfService() {
  return (
    <AuthLayout>
      <Card className='max-h-[85vh] overflow-hidden p-6'>
        <div className='mb-6'>
          <Link to='/sign-in'>
            <Button variant='ghost' size='sm' className='mb-4'>
              <ArrowLeft className='mr-2 h-4 w-4' />
              Back to Login
            </Button>
          </Link>
          <h1 className='text-2xl font-semibold tracking-tight'>
            Terms of Service
          </h1>
          <p className='text-sm text-muted-foreground'>
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>

        <div className='max-h-[calc(85vh-180px)] overflow-y-auto pr-2'>
          <div className='prose prose-sm max-w-none dark:prose-invert'>
          <h2>1. Agreement to Terms</h2>
          <p>
            By accessing and using Menu Points Admin ("the Service"), you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access the Service.
          </p>

          <h2>2. Description of Service</h2>
          <p>
            Menu Points Admin is a restaurant menu management platform that allows businesses to create, manage, and display digital menus. The Service includes but is not limited to:
          </p>
          <ul>
            <li>Menu item creation and management</li>
            <li>Category organization</li>
            <li>QR code generation for menu access</li>
            <li>Multi-language support</li>
            <li>Restaurant branding customization</li>
          </ul>

          <h2>3. User Accounts</h2>
          <p>
            To use certain features of the Service, you must register for an account. You agree to:
          </p>
          <ul>
            <li>Provide accurate, current, and complete information</li>
            <li>Maintain the security of your password</li>
            <li>Accept responsibility for all activities under your account</li>
            <li>Notify us immediately of any unauthorized use</li>
          </ul>

          <h2>4. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the Service for any illegal purpose</li>
            <li>Upload malicious code or content</li>
            <li>Attempt to gain unauthorized access to the Service</li>
            <li>Interfere with or disrupt the Service</li>
            <li>Use the Service to transmit spam or unsolicited messages</li>
          </ul>

          <h2>5. Content Ownership</h2>
          <p>
            You retain all rights to the content you upload to the Service, including menu items, descriptions, and images. By uploading content, you grant us a license to use, store, and display this content solely for the purpose of providing the Service.
          </p>

          <h2>6. Intellectual Property</h2>
          <p>
            The Service and its original content, features, and functionality are owned by Menu Points and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
          </p>

          <h2>7. Termination</h2>
          <p>
            We may terminate or suspend your account immediately, without prior notice or liability, for any reason, including without limitation if you breach the Terms. Upon termination, your right to use the Service will immediately cease.
          </p>

          <h2>8. Limitation of Liability</h2>
          <p>
            In no event shall Menu Points, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the Service.
          </p>

          <h2>9. Changes to Terms</h2>
          <p>
            We reserve the right to modify or replace these Terms at any time. We will provide notice of any significant changes. Your continued use of the Service after such modifications constitutes acceptance of the updated Terms.
          </p>

          <h2>10. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with applicable laws, without regard to its conflict of law provisions.
          </p>

          <h2>11. Contact Information</h2>
          <p>
            If you have any questions about these Terms, please contact us at:
            <br />
            Email: support@menupoints.com
          </p>
        </div>
        </div>
      </Card>
    </AuthLayout>
  )
}
